import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Card,
  CardAction,
  CardButton,
  NotificationIcon,
  Placeholder,
  Exception,
  Contributions,
} from './styles';
import styled from 'styled-components';

import { media } from 'style-utils';
import { NitroIcon, NitroParagraph, NitroText } from 'nitro-components';
import { Divider } from 'material-ui';

const StyledAction = styled(CardAction)`
  & > div:first-child {
    border-right: solid 1px #ddd;
  }
`;
import moment from 'moment';
class NitroCard extends Component {
  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(e) {
    const { action } = this.props;

    if (action) {
      e.preventDefault();
      action();
    }
  }

  render() {
    const {
      action,
      actionText,
      className,
      notificationIcon,
      notificationIconVariant,
      primaryText,
      secondaryText,
      contributionsCount,
      contributionsTotal,
      exemptionsCount,
      exemptionsLength,
      allocationStartDate,
      allocationEndDate,
    } = this.props;

    const cardContent = (
      <div>
        <NitroParagraph size="2" variant="secondary" noMargin align="center">
          {primaryText}
        </NitroParagraph>
        <NitroParagraph size="1" variant="primary" align="center" bold>
          {secondaryText}
        </NitroParagraph>
        {allocationStartDate !== undefined && allocationEndDate !== undefined && (
          <NitroParagraph size="3" align="center" bold>
            {moment(allocationStartDate).format('ddd D MMM YY')} -{' '}
            {moment(allocationEndDate).format('ddd D MMM YY')}
          </NitroParagraph>
        )}
        <Divider style={{ marginBottom: '20px' }} />
        <StyledAction>
          <div className="actionCtn">
            <NitroParagraph
              size="3"
              variant="secondary"
              align="center"
              bold
              noMargin
            >
              Exemptions
            </NitroParagraph>
            <NitroParagraph
              size="3"
              variant="secondary"
              align="center"
              noMargin
            >
              {exemptionsCount} ({exemptionsLength}{' '}
              {exemptionsLength > 1 ? 'days' : 'day'})
            </NitroParagraph>
          </div>
          <div className="actionCtn">
            <NitroParagraph
              size="3"
              variant="secondary"
              align="center"
              bold
              noMargin
            >
              Contributions
            </NitroParagraph>
            <NitroParagraph
              size="3"
              variant="secondary"
              align="center"
              noMargin
            >
              $ {contributionsTotal}
            </NitroParagraph>
          </div>
        </StyledAction>
      </div>
    );

    return (
      <Card className={className}>
        {notificationIcon && (
          <NotificationIcon variant={notificationIconVariant}>
            <NitroIcon
              variant={notificationIconVariant}
              name={notificationIcon}
            />
          </NotificationIcon>
        )}
        {action ? (
          <CardButton onClick={this.handleClick}>{cardContent}</CardButton>
        ) : (
          cardContent
        )}
      </Card>
    );
  }
}

NitroCard.propTypes = {
  action: PropTypes.func,
  actionText: React.PropTypes.string,
  className: React.PropTypes.string,
  notificationIcon: PropTypes.string,
  notificationIconVariant: PropTypes.string,
  primaryText: React.PropTypes.string.isRequired,
  secondaryText: React.PropTypes.string,
};

NitroCard.defaultProps = {
  notificationIconVariant: 'secondary',
};

export default NitroCard;



// WEBPACK FOOTER //
// ./src/features/fbt/driver/components/NitroCard/NitroCard.js